import { useDraggable } from '@dnd-kit/core';
import { QrCode } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useT } from '@/lib/i18n/useT';
import type { DragData } from './dnd';

/**
 * A single draggable "+ Station" chip. Drop it on an event to add a new
 * station to that event. Sits next to the xotski carousel in the PLAN tab.
 */
export function StationSource() {
  const t = useT();
  const data: DragData = { type: 'station' };
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: 'station-source',
    data,
  });
  return (
    <button
      ref={setNodeRef}
      type="button"
      {...listeners}
      {...attributes}
      className={cn(
        'inline-flex shrink-0 cursor-grab items-center gap-2 rounded-lg border border-dashed border-[var(--color-xk-border)] bg-[var(--color-bg-base)] px-3 py-2 text-[11px] font-extrabold uppercase tracking-widest text-[var(--color-xk-lavender)] transition-colors hover:border-[var(--color-accent-ink)] active:cursor-grabbing',
        isDragging && 'opacity-40',
      )}
    >
      <QrCode className="h-4 w-4 text-[var(--color-accent-ink)]" />
      {t('planner.stationSource.label')}
    </button>
  );
}
